import { ControlType, Property, PropertyType } from "../../../base/types";

import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const MaterialIconComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const icon: string | undefined = properties[Property.MaterialIcon];

    return (<MUIIcon iconName={icon || 'InsertEmoticonOutlinedIcon'} className={className} />)
}

Registry.addControl({
    id: "ec95f4ae-19b9-4b8b-90c1-89498e7996ac",
    name: "Material Icon",
    type: ControlType.MaterialIcon,
    properties: [
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    ],
    component: MaterialIconComponent
})
